export default __webpack_public_path__ + "static/media/valido.535eff78.svg";